import { createClient } from '@supabase/supabase-js';
import type { Database } from '../data/database.types';

/**
 * The single Supabase client for the app.
 *
 * Uses the anon key, which is public by design. Server-side authorization is
 * enforced by Postgres row-level security, not by the client (spec §4a), so
 * this key grants no access beyond what each row's RLS policy allows.
 */

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!url || !anonKey) {
  throw new Error(
    'Supabase is not configured. Copy .env.example to .env.local and set ' +
      'VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.',
  );
}

export const supabase = createClient<Database>(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
